import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SummaryAction } from "../../actions/summary";

const API_URL =
  "https://sfastaging.nyggs.com/backend/out-of-location-visit/v1/get-location-visit-detail";

// ---------- Dialog Component ----------
function ViewDefaultMeetingDialog({ open, onClose, meetingData }) {
  const { locationVisitId, geofenceDefaultLatLong, geofenceId } =
    meetingData || {};
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  React.useEffect(() => {
    if (open && locationVisitId) {
      fetchVendorVisitDetail(locationVisitId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, locationVisitId]);

  const fetchVendorVisitDetail = async (id) => {
    // debugger;
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const res = await SummaryAction.fetchDefaultMeetingDetails({ locationVisitId });
      if (res !== null && res.responseCode === 200) {
        setData(res.data);
      } else {
        setError(res.responseDescription || "Failed to fetch details");
      }
    } catch (err) {
      console.log(err);
      setError("Something went wrong while fetching visit details");
    } finally {
      setLoading(false);
    }
  };

  const formatVehicles = (vehicles = []) =>
    vehicles.map((v) => `${v.vehicleType}(${v.quantity})`).join(", ");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Vendor Visit Details
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {loading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={150}
          >
            <CircularProgress />
          </Box>
        )}

        {!loading && error && (
          <Typography color="error" align="center" sx={{ py: 3 }}>
            {error}
          </Typography>
        )}

        {!loading && !error && data && (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell>
                    <strong>Contact Person Name</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Vendor Type</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Vendor Category</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Transporter / Vendor Name</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Reason For Visit</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Vehicles</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{data.contactPersonName || "-"}</TableCell>
                  <TableCell>{data.vendorType || "-"}</TableCell>
                  <TableCell>{data.vendorCategory || "-"}</TableCell>
                  <TableCell>{data.transporterVendorName || "-"}</TableCell>
                  <TableCell>{data.reasonForVisit || "-"}</TableCell>
                  <TableCell>
                    {data.vehicles && data.vehicles.length > 0 ? (
                      <Tooltip title={formatVehicles(data.vehicles)} arrow>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <InfoOutlinedIcon fontSize="small" sx={{ mr: 0.5 }} />
                          {data.vehicles.length} Type(s)
                        </Box>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ViewDefaultMeetingDialog;
